/**
 * @class Home
 * @param element HTMLElement
 * @constructor
 */
function Home(element){
	if(element === null){
		throw new TypeError("Invalid element.");
	}

	this._element = element;
	this._document = element.ownerDocument;
	this._window = this._document.defaultView;
	this._wheelHandlerBound = this._wheelHandler.bind(this);
	this._scrollHandlerBound = this._scrollHandler.bind(this);
	this._keydownHandlerBound = this._keydownHandler.bind(this);
	this._skipClickHandlerBound = this._skipClickHandler.bind(this);
	this._scrollAnimationFrameHandlerBound = this._scrollAnimationFrameHandler.bind(this);
	this._userScrollTimeoutHandlerBound = this._userScrollTimeoutHandler.bind(this);
	this._anchorClickHandlerBound = this._anchorClickHandler.bind(this);

	/** @type NodeList */
	var elements;
	// Object VR
	if((elements = element.getElementsByClassName("index_apps-canvas")).length){
		this._objectVR = new ObjectVR(elements[0]);
	}

	if((elements = element.getElementsByClassName("index_strong-points-content")).length){
		this._contentElement = elements[0];
	}

	var numElements;
	var index;
	// Prepare elements (remove already added *--target class) + add events listeners
	if(
		numElements = (this._strongPointsElements = element.getElementsByClassName("index_strong-point")).length
	){
		for(index = 0; index < numElements; index++){
			this._strongPointsElements[index].classList.remove("index_strong-point--target");
		}
	}
	if(numElements){
		this._updateStrongPointStyles();
	}
	if(
		numElements
		&& (numElements = (this._anchorsElements = element.getElementsByClassName("index_strong-points-toc-anchor")).length)
	){
		for(index = 0; index < numElements; index++){
			this._anchorsElements[index].classList.remove("index_strong-points-toc-anchor--target");
			this._anchorsElements[index].addEventListener("click", this._anchorClickHandlerBound, false);
		}
	}
	if((elements = element.getElementsByClassName("index_apps-skip")).length){
		this._skipElement = elements[0];
		this._skipElement.addEventListener("click", this._skipClickHandlerBound, false);
	}

	this._document.addEventListener("wheel",this._wheelHandlerBound, false);
	this._window.addEventListener("scroll", this._scrollHandlerBound, false);
	this._document.addEventListener("keydown", this._keydownHandlerBound, false);
	this._updatePosition(0);
}

Home.POSITION_PIXEL = 100;
Home.POSITION_LINES = 3;
/**
 * Duration of scroll transition in ms
 * @type Number
 */
Home.SCROLL_TRANSITION_DURATION = 400;
/**
 * Dely between user's scroll and auto scroll in ms
 * @type Number
 */
Home.AUTO_SCROLL_DELAY = 200;

/** @type DocumentView */
Home.prototype._window = null;
/** @type HTMLDocument */
Home.prototype._document = null;
/** @type HTMLElement */
Home.prototype._element = null;
/** @type HTMLElement */
Home.prototype._contentElement = null;
/** @type HTMLElement */
Home.prototype._skipElement = null;
/** @type NodeList|HTMLCollection */
Home.prototype._anchorsElements = null;
/** @type NodeList|HTMLCollection */
Home.prototype._strongPointsElements = null;
/** @type number */
Home.prototype._currentStrongPointIndex = -1;
/** @type number */
Home.prototype._position = -1;
/** @type ObjectVR */
Home.prototype._objectVR = null;
/** @type Number */
Home.prototype._deltaY = 0;
/** @type Number */
Home.prototype._deltaMode = 0;
/** @type Number */
Home.prototype._wheelTime = 0;
/** @type Number */
Home.prototype._scrollTransitionCurrentX = NaN;
Home.prototype._scrollTransitionCurrentY = NaN;
Home.prototype._scrollTransitionToX = NaN;
Home.prototype._scrollTransitionToY = NaN;
Home.prototype._scrollTransitionFromX = NaN;
Home.prototype._scrollTransitionFromY = NaN;
Home.prototype._scrollTransiting = false;
Home.prototype._scrollTransitionStart = 0;
/** @type Function **/
Home.prototype._scrollAnimationFrameHandlerBound = null;
Home.prototype._scrollAnimationFrameRequestID = null;
Home.prototype._userScrollTimeoutID = null;
/** @type Function */
Home.prototype._userScrollTimeoutHandlerBound = null;
Home.prototype._wheelHandlerBound = null;
Home.prototype._scrollHandlerBound = null;
Home.prototype._keydownHandlerBound = null;
Home.prototype._skipClickHandlerBound = null;
Home.prototype._anchorClickHandlerBound = null;

Home.prototype._updateStrongPointStyles = function _updateStrongPointStyles(){
	var element = this._element.querySelector(".index_strong-point-style");
	if(!element){
		return;
	}

	var rules = element.sheet.cssRules;
	var ruleSelectorTail = ".index_strong-point-title::before";
	var ruleSelectorTailLength = ruleSelectorTail.length;
	var urlRegExp = /url\('([^']*)|url\("([^"]*)|url\(([^\)]*)/;
	for(var ruleIndex = 0, numRules = rules.length, rule; ruleIndex < numRules; ruleIndex++){
		rule = rules[ruleIndex];
		if(rule.type == CSSRule.STYLE_RULE && rule.selectorText.substr(-ruleSelectorTailLength) == ruleSelectorTail && !!rule.style.backgroundImage){
			// first background image
			var result = urlRegExp.exec(rule.style.backgroundImage);
			var url = result ? result[1] || result[2] || result[3] : null;
			var image = new Image();
			image.src = url;
			// TODO use it in a canvas to detect average bound
			// TODO and update "#ID .index_strong-point-title" rule to impact height (and margins?)
		}
	}
};

/**
 *
 * @param event Event
 * @private
 */
Home.prototype._skipClickHandler = function _skipClickHandler(event){
	event.preventDefault();
	this._updatePosition(1);
};

Home.prototype._targetStrongPoint = function _targetStrongPoint(targetIndex){
	/** @type HTMLElement */
	var element;
	/** @type DOMTokenList */
	var classList;
	var index;
	var numElements;

	// Clamp
	// -1 means no element selected (before first one)
	targetIndex = Math.max(Math.min(targetIndex, this._strongPointsElements.length -1), -1);
	if(targetIndex == this._currentStrongPointIndex){
		// Do nothing
		return;
	}
	this._currentStrongPointIndex = targetIndex;

	/*
	 Update points classes
	 */
	for(index = 0, numElements = this._strongPointsElements.length; index < numElements; index++){
		element = this._strongPointsElements[index];
		classList = element.classList;
		if(index == targetIndex){
			classList.remove("index_strong-point--untarget");
			classList.add("index_strong-point--target");
			this._contentElement.style.backgroundColor = element.dataset.color;
		}else if(classList.contains("index_strong-point--target")){
			classList.remove("index_strong-point--target");
			classList.add("index_strong-point--untarget");
		}
	}

	/*
	 Update anchors classes
	 */
	for(index = 0, numElements = this._anchorsElements.length; index < numElements; index++){
		element = this._anchorsElements[index];
		classList = element.classList;
		if(index == targetIndex){
			classList.remove("index_strong-points-toc-anchor--untarget");
			classList.add("index_strong-points-toc-anchor--target");
		}else if(classList.contains("index_strong-points-toc-anchor--target")){
			classList.remove("index_strong-points-toc-anchor--target");
			classList.add("index_strong-points-toc-anchor--untarget");
		}
	}
};

/**
 *
 * @param event Event
 * @private
 */
Home.prototype._anchorClickHandler = function _anchorClickHandler(event){
	event.preventDefault();
	var anchorElement = event.currentTarget;
	var position = 1 + Array.prototype.indexOf.call(this._anchorsElements, anchorElement);
	this._updatePosition(position);
};

Home.prototype._wheelHandler = function _wheelHandler(event){
	// If scroll on vertical/y axis (could be horizontal/x or z)
	if(event.deltaY != 0){
		event.preventDefault();
	}


	// No change spam
	// If last change occured in less than n time don't handle it.
	// That let the user stop wheeling before change to the next position
	// If it's equal to 0, don't block it
	if(this._wheelTime > 0 && (Date.now() - this._wheelTime) < 400){
		return;
	}
	this._wheelTime = 0;

	var deltaMode = event.deltaMode;
	var deltaY = (this._deltaMode == deltaMode ? this._deltaY : 0) + event.deltaY;
	this._deltaMode = deltaMode;

	var positionOffset = 0;
	switch(deltaMode){
		case WheelEvent.DOM_DELTA_PIXEL:
			// Flooring round to low value in negative too Math.floor(-2.5) >> -3
			// So convert to int instead: deltaY | 0;
			// Or: Math.sign(deltaY) >= 0 ? Math.floor(deltaY) : Math.ceil(deltaY);
			positionOffset = deltaY / Home.POSITION_PIXEL | 0;
			deltaY %= Home.POSITION_PIXEL;
			break;
		case WheelEvent.DOM_DELTA_LINE:
			positionOffset = deltaY / Home.POSITION_LINES | 0;
			deltaY %= Home.POSITION_LINES;
			break;
		case WheelEvent.DOM_DELTA_PAGE:
			positionOffset = deltaY;
			deltaY = 0;
			break;
	}
	// No multiple positions in same time
	positionOffset = Math.min(Math.max(positionOffset, -1), 1);
	this._deltaY = deltaY;

	// If position changed
	if(this._updatePosition(this._position + positionOffset)){
		this._wheelTime = Date.now();
	}
};

Home.prototype._updatePosition = function _updatePosition(position){
	// Clamp
	position = Math.max(Math.min(position, this._strongPointsElements.length), 0);

	if(this._position != position){
		this._position = position;
		var classList = this._skipElement.classList;
		if(position == 0){
			this._objectVR.active = true;
			classList.add("index_apps-skip--active");
			classList.remove("index_apps-skip--inactive");
			// Scroll to top
			this._scrollTo(this._window.scrollX, 0);
		}else{
			this._objectVR.active = false;
			classList.remove("index_apps-skip--active");
			classList.add("index_apps-skip--inactive");
			// Scroll to bottom
			this._scrollTo(this._window.scrollX, this._window.scrollMaxY);
		}
		this._targetStrongPoint(position - 1);

		return true;
	}

	return false;
};

Home.prototype._keydownHandler = function _keydownHandler(event){
	switch(event.keyCode){
		// Up key
		case 38:
		// Page up key
		case 34:
			event.preventDefault();
			// Up
			this._updatePosition(this._position - 1);
			break;
		// Down key
		case 40:
		// Page down key
		case 33:
			event.preventDefault();
			// Down
			this._updatePosition(this._position + 1);
			break;
		// Space
		case 32:
			event.preventDefault();
			// Loop
			this._updatePosition((this._position + 1) % (this._strongPointsElements.length + 1));
			break;
	}
};

// Will update window.scrollY
Home.prototype._scrollTo = function _scrollTo(x, y){
	this._scrollTransitionFromX = this._window.scrollX;
	this._scrollTransitionFromY = this._window.scrollY;
	this._scrollTransitionToX = x;
	this._scrollTransitionToY = y;
	this._scrollTransitionStart = Date.now();
	// Remove timeout (if any)
	this._clearUserScrollTimeout();
	// If not already transiting
	if(!this._scrollTransiting){
		this._scrollTransiting = true;
		// First tick
		this._scrollTransitionTick(0);
		this._scrollAnimationFrameRequestID = requestAnimationFrame(this._scrollAnimationFrameHandlerBound);
	}
};

/**
 * Stop scroll transition
 * @private
 */
Home.prototype._stopScrollTransition = function _stopScrollTransition(){
	// Stop only if transiting
	if(this._scrollTransiting){
		this._scrollTransiting = false;
		cancelAnimationFrame(this._scrollAnimationFrameRequestID);
	}
};

/**
 *
 * @param time
 * @private
 */
Home.prototype._scrollAnimationFrameHandler = function _scrollAnimationFrameHandler(time){
	var progress = (Date.now() - this._scrollTransitionStart) / Home.SCROLL_TRANSITION_DURATION;
	// Limits 0 to 1
	progress = Math.min(Math.max(progress, 0), 1);
	this._scrollTransitionTick(progress);
	// If progression is complete
	if(progress == 1){
		this._scrollTransiting = false;
	}
	// Else, continue
	else{
		this._scrollAnimationFrameRequestID = requestAnimationFrame(this._scrollAnimationFrameHandlerBound);
	}
};

/**
 * Update scroll position (used by scroll transition)
 * @param {number} progress
 * @private
 */
Home.prototype._scrollTransitionTick = function _scrollTransitionTick(progress){
	var x = Ease.outQuart(progress, this._scrollTransitionFromX, this._scrollTransitionToX);
	var y = Ease.outQuart(progress, this._scrollTransitionFromY, this._scrollTransitionToY);
	this._scrollTransitionCurrentX = x;
	this._scrollTransitionCurrentY = y;
	// Always use rounded values
	this._window.scrollTo(Math.round(x), Math.round(y));
};

/**
 *
 * @param event
 * @private
 */
Home.prototype._scrollHandler = function _scrollHandler(event){
	// Remove previous timeout (if any)
	this._clearUserScrollTimeout();

	// If scroll transition and values are not the same, or no scroll transition
	// It's not our defined value, that seem that the user scrolled?
	if(!this._scrollTransiting || (
		// We need to floor values, since with some browsers, scroll valuers are floored while on others values are not rounded (floats)
		Math.round(this._scrollTransitionCurrentX) != this._window.scrollX
		|| Math.round(this._scrollTransitionCurrentY) != this._window.scrollY
	)){
		// Stop scroll animation
		this._stopScrollTransition();
		// Create a new one
		this._userScrollTimeoutID = setTimeout(this._userScrollTimeoutHandlerBound, Home.AUTO_SCROLL_DELAY);
	}
};

Home.prototype._clearUserScrollTimeout = function _clearUserScrollTimeout(){
	if(this._userScrollTimeoutID){
		clearTimeout(this._userScrollTimeoutID);
		this._userScrollTimeoutID = null;
	}
};

Home.prototype._userScrollTimeoutHandler = function _userScrollTimeoutHandler(){
	this._userScrollTimeoutID = null;
	var scrollY = this._window.scrollY;
	var scrollMaxY = this._window.scrollMaxY;

	// If in first half part (but not == 0)
	if(scrollY < scrollMaxY / 2){
		// The position is not ok
		if(this._position > 0){
			// Update position
			this._updatePosition(0);
		}
		// Or the scroll is not ok
		else if(scrollY > 0){
			// Just scroll
			this._scrollTo(this._window.scrollX, 0);
		}
	}
	// In second half part
	else{
		// The position is not ok
		if(this._position < 1){
			// Update position
			this._updatePosition(1);
		}
		// Or the scroll is not ok
		else if(scrollY < scrollMaxY){
			// Just scroll
			this._scrollTo(this._window.scrollX, scrollMaxY);
		}
	}
};

Home.prototype.clear = function clear(){
	if(this._objectVR){
		this._objectVR.clear();
	}
	clearTimeout(this._userScrollTimeoutID);
	cancelAnimationFrame(this._scrollAnimationFrameRequestID);
	for(var index = 0, numElements = this._anchorsElements.length; index < numElements; index++){
		this._anchorsElements[index].addEventListener("click", this._anchorClickHandlerBound, false);
	}
	if(this._skipElement){
		this._skipElement.removeEventListener("click", this._skipClickHandlerBound, false);
	}

	this._document.removeEventListener("wheel", this._wheelHandlerBound, false);
	this._window.removeEventListener("scroll", this._scrollHandlerBound, false);
	this._document.removeEventListener("keydown", this._keydownHandlerBound, false);

	return true;
};